import { gql } from '@apollo/client';
const ADD_CONVERSATION_MESSAGE = gql `
  mutation AddConversationMessage(
    $conversationId: ID!
    $text: String!
    $image: String
    $mentions: [MentionDataInput!]
  ) {
    sendMessage(conversationId: $conversationId, image: $image, text: $text, mentions: $mentions) {
      message {
        id
        text
        image
        createdDate
        sender {
          id
          email
          username
        }
      }
    }
  }
`;
export default ADD_CONVERSATION_MESSAGE;
